import { render } from "./QueueOrders.vue?vue&type=template&id=71b43866"
import script from "./QueueOrders.vue?vue&type=script&lang=js"
export * from "./QueueOrders.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__